import React from 'react';
import { Link } from 'react-router-dom';
import { Seo, breadcrumbJsonLd } from '@/components/Seo';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import { LOCATIONS, SITE } from '@/data/site-config';
import { MapPin, ArrowRight } from 'lucide-react';

export default function LocationsHub() {
  const path = '/locations';
  const breadcrumbs = [{ name: 'Home', path: '/' }, { name: 'Locations', path }];
  return (
    <>
      <Seo title="Service Area & Locations" description={`Fitness Training 360 serves all of ${SITE.county} from our private studio in ${SITE.city}, FL.`} canonical={path} jsonLd={breadcrumbJsonLd(breadcrumbs)} />
      <Breadcrumbs items={breadcrumbs} />
      <section className="container-x py-10">
        <span className="eyebrow">Service area</span>
        <h1 className="font-display text-4xl md:text-5xl font-bold mt-3">Serving {SITE.county}, Florida.</h1>
        <p className="text-[color:var(--ft-muted)] text-lg mt-4 max-w-3xl">Our studio is located at <strong className="text-[color:var(--ft-text)]">{SITE.address.full}</strong>. We coach clients from across {SITE.county} — the surrounding communities are short drives away. We do not operate separate physical studios in those areas; clients come to our private {SITE.city} studio.</p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mt-8">
          {LOCATIONS.map((l) => (
            <Link key={l.slug} to={`/locations/${l.slug}`} className="surface card-hover p-5 block">
              <div className="flex items-center gap-2"><MapPin size={16} className="text-accent" /><h2 className="font-display font-semibold">{l.name}, FL</h2></div>
              <p className="text-[color:var(--ft-muted)] text-sm mt-2">{l.context}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm text-accent">{l.drive} drive <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
